import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__';
import { UpdateUserInput } from '@/__generated__/graphql.ts';

const UPDATE_USER_PROFILE = gql(`
  mutation UpdateUserProfile($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      fullName
      avatar {
        key
      }
      backgroundImage {
        key
      }
      bio
      xComHandle
    }
  }
`);

export const useUpdateUserProfile = () => {
  const toast = useToast();
  const [updateUserProfileMutation, result] = useMutation(UPDATE_USER_PROFILE);
  const updateUserProfile = (input: UpdateUserInput) => {
    updateUserProfileMutation({
      variables: {
        input,
      },
      onCompleted() {
        toast.info({
          title: 'Profile was updated',
        });
      },
      onError() {
        toast.error({
          title: 'Failed to update profile',
        });
      },
    });
  };

  return [updateUserProfile, result] as const;
};
